import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const LogoSectionAbout = () => {
  return (
    <div className="uk-section uk-section-small uk-margin-top">
      <div className="uk-container uk-container-small">
        <div
          className="uk-grid uk-child-width-1-4 uk-child-width-expand@m logos-grid"
          uk-grid="true"
          uk-scrollspy="cls: uk-animation-scale-down; target: > div; delay: 200"
        >
          <div>
            <StaticImage
              src="../../images/logo-1.svg"
              alt="Logo 1"
              formats={["AUTO", "WEBP", "AVIF"]}
              placeholder="blurred"
              uk-tool-tip="Fancy image with tooltip"
              title="Logo 1"
            />
          </div>
          <div>
            <StaticImage
              src="../../images/logo-2.svg"
              alt="Logo 2"
              formats={["AUTO", "WEBP", "AVIF"]}
              placeholder="blurred"
              title="Logo 2"
            />
          </div>
          <div>
            <StaticImage
              src="../../images/logo-3.svg"
              alt="Logo 3"
              formats={["AUTO", "WEBP", "AVIF"]}
              placeholder="blurred"
              title="Logo 3"
            />
          </div>
          <div>
            <StaticImage
              src="../../images/logo-6.svg"
              alt="Logo 6"
              formats={["AUTO", "WEBP", "AVIF"]}
              placeholder="blurred"
              title="Logo 6"
            />
          </div>
          <div>
            <StaticImage
              src="../../images/logo-7.svg"
              alt="Logo 7"
              formats={["AUTO", "WEBP", "AVIF"]}
              placeholder="blurred"
              title="Logo 7"
            />
          </div>
          <div>
            <StaticImage
              src="../../images/logo-8.svg"
              alt="Logo 8"
              formats={["AUTO", "WEBP", "AVIF"]}
              placeholder="blurred"
              title="Logo 8"
            />
          </div>
          <div>
            <StaticImage
              src="../../images/logo-4.svg"
              alt="Logo 4"
              formats={["AUTO", "WEBP", "AVIF"]}
              placeholder="blurred"
              title="Logo 4"
            />
          </div>
          <div>
            <StaticImage
              src="../../images/logo-5.svg"
              alt="Logo 5"
              formats={["AUTO", "WEBP", "AVIF"]}
              placeholder="blurred"
              title="Logo 5"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LogoSectionAbout
